/* istanbul ignore file */
import { MarketConfig } from "../index";

const config: MarketConfig = {
  supportLangs: [
    {
      name: "Eng",
      label: "English",
      locale: "en-GB",
    },
    {
      name: "繁",
      label: "繁",
      locale: "zh-HK",
    },
  ],
  fallbackLocale: "en-GB",
  primaryColor: "#0081c6",
  footerMarket: "ipropertymy",
  sharpieBucket: "my-iproperty",
  sharpieOriginalBucket: "my-iproperty-original",
};
export default config;
